module.exports = __webpack_public_path__ + "static/media/05.bd7f7377.jpg";